import { useEffect, useState } from 'react';

import { ConfigProvider as AntConfigProvider, ConfigProviderProps } from 'antd';

import { THEME_DARK, THEME_LIGHT } from 'shared/consts';
import { WebApp } from 'shared/utils';

interface IConfigProviderProps extends ConfigProviderProps {
	children: React.ReactNode;
}

export const ConfigProvider = ({ children, ...props }: IConfigProviderProps) => {
	const [theme, setTheme] = useState(
		!!WebApp?.initData && WebApp?.colorScheme === 'light' ? THEME_LIGHT() : THEME_DARK(),
	);

	const onThemeChanged = () => {
		setTheme(!!WebApp?.initData && WebApp?.colorScheme === 'light' ? THEME_LIGHT() : THEME_DARK());
	};

	useEffect(() => {
		WebApp?.onEvent('themeChanged', onThemeChanged);
		return () => {
			WebApp?.offEvent('themeChanged', onThemeChanged);
		};
	}, []);

	return (
		<AntConfigProvider {...props} theme={theme}>
			{children}
		</AntConfigProvider>
	);
};
